import React from 'react';
import { connect } from 'react-redux';
import Project from '../components/Project';

const ProjectContainer = React.createClass({
  componentDidMount() {
    const body = document.getElementsByTagName('body')[0];
    document.title = `Nathan Kleekamp | ${ this.getProject().title }`;
    body.className = 'default';
    this.setMetaDescription();
  },


  setMetaDescription() {
    const desc = document.querySelectorAll('meta[name=description');
    desc[0].content = this.getProject().excerpt;
  },


  getProject() {
    return this.props.data.filter(item => {
      return item.slug === this.props.params.slug;
    })[0];
  },


  render() {
    const props = this.props;

    return (
      <Project project={ this.getProject() }></Project>
    );
  }
});




const mapStateToProps = ({ app }) => {
  const data = app.data;

  return {
    data
  };
};

export default connect(mapStateToProps)(ProjectContainer);




// WEBPACK FOOTER //
// ./app/src/Portfolio/containers/ProjectContainer.js